import { type FC } from "react";

import { MAX_AXIS_TICKS } from "./chartAxis";
import * as Styled from "./ChartXAxis.styles";

export const ChartXAxisSkeleton: FC = () => {
  return (
    <Styled.Root>
      {Array.from({ length: MAX_AXIS_TICKS }, (_, index) => (
        <Styled.TickSkeleton key={index} />
      ))}
    </Styled.Root>
  );
};
